import * as React from "react";
const SvgFiRrCarRear = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-car-rear_svg__a)">
      <path
        fill="#062147"
        d="m23.598 11.718-2.701-7.427A5.01 5.01 0 0 0 16.199.999H7.802A5.01 5.01 0 0 0 3.104 4.29L.402 11.718A6.6 6.6 0 0 0 0 14v1c0 1.629.795 3.065 2.004 3.978 0 .008-.004.014-.004.022v2c0 1.654 1.346 3 3 3s3-1.346 3-3v-1h8v1c0 1.654 1.346 3 3 3s3-1.346 3-3v-2q-.002-.011-.004-.022C23.206 18.065 24 16.629 24 15v-1c0-.782-.136-1.549-.402-2.282M4.982 4.974A3.01 3.01 0 0 1 7.801 3h8.396c1.257 0 2.39.793 2.819 1.975L20.48 9H3.518zM6 21a1.001 1.001 0 0 1-2 0v-1.101q.486.1 1 .101h1zm14 0a1.001 1.001 0 0 1-2 0v-1h1q.514-.001 1-.101zm-1-3h-3v-1a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1H5c-1.654 0-3-1.346-3-3h2a1 1 0 1 0 0-2H2.121c.044-.201.089-.403.16-.598L2.791 11h18.418l.51 1.402c.071.195.116.396.16.598H20a1 1 0 1 0 0 2h2c0 1.654-1.346 3-3 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-car-rear_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCarRear;
